import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  OrderedList,
  Text,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const MissingLinkBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '500px', lg: '700px' }}
      maxH={{ xs: '500px', lg: '700px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
          {/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Exploring the &apos;Missing-Link&apos;: The India Opportunity for
            Growth Stage Impact Funds
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Ramraj Pai
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Author
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          <Flex
            flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
            columnGap="20px"
            rowGap="16px"
          >
            <Flex
              flexDir="column"
              alignItems={{ xs: 'center', sm: 'flex-start' }}
              rowGap="8px"
            >
              <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                <Avatar
                  name="Ramraj Pai"
                  w="100%"
                  h="100%"
                  src="/jpg/Ramraj.jpg"
                  objectFit="cover"
                />
              </Box>
              <Flex flexDir="column" rowGap="4px">
                <Heading
                  variant="blogQuestion"
                  textAlign={{ xs: 'center', sm: 'left' }}
                >
                  Ramraj Pai
                </Heading>
                <Text
                  variant="blogAnswer"
                  textAlign={{ xs: 'center', sm: 'left' }}
                  fontStyle="italic"
                >
                  Chief Executive Officer, Impact Investors Council
                </Text>
              </Flex>
              <Flex
                columnGap={{ xs: '4px', md: '16px' }}
                justifyContent={{ xs: 'center', sm: 'flex-start' }}
                transform={{ xs: 'translateX(12px)', sm: 'none' }}
              >
                <Box alignSelf="center">
                  <Link
                    href="https://www.linkedin.com/in/ramraj-pai-56b50614"
                    target="_blank"
                  >
                    <IconButton
                      aria-label="linkedin"
                      icon={
                        <FaLinkedin
                          size="28px"
                          color="rgba(100, 100, 140, 0.6)"
                        />
                      }
                      variant="unstyled"
                      cursor="pointer"
                    />
                  </Link>
                </Box>
              </Flex>
            </Flex>
          </Flex>
        </Flex>

        <Box w={{ xs: '100%', md: '73%' }}>
          <Text variant="blogAnswer" pb="20px">
            The impact investing market in India has experienced significant
            growth in recent years. The analysis by Impact Investors Council
            (IIC) shows that equity investments into Indian impact enterprises
            reached a record high of ~$7 Bn in 2021, with more than $13 Bn
            invested over the past three years.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            As the impact sector expands and impact enterprises grow, there is
            an urgent need for growth-stage impact funds focused on India to
            support the transition of these enterprises beyond early-stage
            funding. The existence of such funds is vital to maintain the
            development and maturity of India&apos;s impact investing ecosystem,
            given the emergence of the following themes:
          </Text>
          <OrderedList>
            <ListItem pb="14px">
              <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                The demand for impact capital in growth stage (and beyond) deals
                has increased significantly (80%) from 2017-2021, relative to a
                40% increase in total impact deal flow. This shows that a
                growing number of Indian impact enterprises are scaling up,
                leading to stronger investment demand and a unique
                risk-return-impact profile suitable for growth-stage funds.
              </Text>
            </ListItem>
            {/* 2nd */}
            <ListItem pb="14px">
              <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                On the supply side, Large LPs globally and in India are showing
                an increased interest in private sector opportunities with
                strong ESG and impact credentials. Investing in such
                opportunities can provide a strong foundation for scalable
                growth with returns, creating a strong business case for
                combining financial and social impact.
              </Text>
            </ListItem>
            {/* 3rd */}
            <ListItem pb="14px">
              <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                It is important for impact enterprises to stay focused on their
                core impact thesis as they mature and not shift their business
                model to prioritize profit over social impact. Growth stage
                impact funds can help prevent mission drift by incentivizing
                impact enterprises to remain socially responsible.
              </Text>
            </ListItem>
          </OrderedList>
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Absence of impact funding in late-stage, higher-ticket deals
            represents an untapped opportunity for impact investors
          </Heading>
          <br />
          <Text variant="blogAnswer" pb="20px">
            IIC analysis indicates an untapped opportunity for impact funders in
            larger deals in later stages. Impact funders contribute less as deal
            size increases, with only 20% in the largest deals. Impact investing
            is becoming more mainstream with growing interest from traditional
            asset managers and capital providers. This presents opportunities
            for larger impact and ESG funds to participate in larger investments
            and help social enterprises scale up (refer Chart 1)
          </Text>
          <Img src="/png/graph.png" alt="graph" my="1rem" />
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Domestic Impact GPs dominate smaller ticket, early-stage deals while
            open spaces remain in late-stage impact funding
          </Heading>
          <br />
          <Text variant="blogAnswer" pb="20px">
            An analysis of impact investor funding shows that India-based impact
            GPs are dominant in small early-stage deals but have a limited
            presence in larger later-stage deals, making up only 25% of invested
            capital (refer Chart 2). The limited funding for later-stage deals
            comes from international impact GPs, DFIs, and others.
          </Text>{' '}
          <Text variant="blogAnswer" pb="20px">
            The trend reflects the limitations of Indian impact GPs structured
            as early-stage venture platforms, leading to a funding gap for
            growth-stage social enterprises, which are partially filled by
            commercial investors. Growth-stage social enterprises offer a more
            attractive investment opportunity due to proven impact and financial
            return potential, making them attractive for LPs, international
            impact funds, and India-based growth-stage impact funds.
          </Text>
          <Img src="/png/graph2.png" alt="graph-2" my="1rem" />
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Conclusion
          </Heading>
          <br />
          <Text variant="blogAnswer" pb="20px">
            The Indian equity impact investing market is expected to grow as the
            country needs to spend ~$170 Bn annually to achieve the Sustainable
            Development Goals by 2030. To maximize the potential of India&apos;s
            social innovation, it is important to bring in asset managers
            capable of financing impact deals over $20 million, offering
            opportunities for larger impact and ESG funds to invest in
            higher-value deals.
          </Text>
          <Text variant="blogAnswer" mb="16px">
            To read more, download the report &nbsp;
            <Link
              as="a"
              href="https://iiic.in/research-publication/#The-India-Opportunity-for-Growth-Stage-Impact-Funds"
              target="_blank"
              style={{ color: 'blue', textDecoration: 'underline' }}
            >
              here
            </Link>
          </Text>
        </Box>
      </Flex>
      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default MissingLinkBlog;
